module.exports = __webpack_public_path__ + "img/bzdLOGO.b5ab4a74.png";